import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { environment } from "../../environments/environment";

@Injectable({
  providedIn: "root",
})
export class WorkerService {
  constructor(private http: HttpClient) {}

  runWorker(worker: string): Observable<any> {
    return this.http.post(
      `${environment.apiUrls.worker}/run/${worker}?triggerType=Manually`,
      {}
    );
  }

  static readonly Workers = {
    Funds: "funds",
    AcquiredFunds: "acquired-funds",
    Accounts: "funds/accounts",
    Managers: "managers",
    InvestedFunds: "invested-funds",
    Ballast: "ballast",
    Shareholders: "shareholders",
    FundStock: "fund-stock",
    FixedIncomeStock: "fixed-income-stock",
    VariableIncomeStock: "variable-income-stock",
    OtherAssetStock: "other-asset-stock",
    DerivativeStock: "derivative-stock",
    SwapCetipStock: "swap-cetip-stock",
  };
}
